import { Component, OnInit, OnDestroy } from '@angular/core';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'roadmap',
    templateUrl: './terms-and-conditions.component.html'
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {

    constructor(private storageService: StorageService) {

    }

    isLoggedIn: boolean = false;

    ngOnInit() {
        this.isLoggedIn = this.storageService.getItem("token") != undefined;
        window.scrollTo(0, 0);
    }

    ngOnDestroy() {
    }

}
